import React, { useEffect, useRef, useState } from "react";
import './AddOfferModal.scss';
import Modal from 'react-bootstrap/Modal';
import { Button, Form, Spinner } from 'react-bootstrap';
import * as _ from "lodash";
import AddOfferDetails from './AddOfferDetails.old'; 
import OfferDetailsConfirmation from './OfferDetailsConfirmation';
import AddOfferModel from "./addOfferModel";
import Offer from "domain/offer";
import IAppStore from "app/IAppStore";
import { Offering } from "features/settings/offerings/offering";
import PhysicalLocation from "domain/physicalLocation";
import OfferType, { OfferTypeEnum, toContractType, getOfferTypeName, fromContractType } from "domain/offerType";
import * as OfferActions from "features/offers/offers.actions";
import * as ContractActions from "features/contracts/contracts.actions";
import Commodity from "domain/commodity";
import { DeliveryMethod, ExcludedDeliveryMethodsForDPContracts } from "domain/deliveryMethod";
import DeliveryPeriod from "domain/deliveryPeriod";
import ValidationError from "common/validationError";
import Permissions from "common/security/permissions";
import { PaymentOption, listPaymentOptionsForOffer } from "domain/paymentOption";
import OfferHedgeSettings from './OfferHedgeSettings';
import { OrderType } from "domain/orderType";
import FuturesContract from "domain/futuresContract";
import Contract, { ContractType } from "domain/contract";
import { getNextDayForGivenDate, getPreviousDayForGivenDate } from 'common/formatters';
import { roundCents } from "common/decimal";
import commodityBalanceService from 'features/commodityBalance/commodityBalance.service'
import { getCommodityBalanceType } from "domain/commodityBalance";
import * as NP from "number-precision";
import futuresContractsService from "features/futuresContracts/futuresContracts.service";
import producerService from "features/settings/producers/producerService";
import { Producer } from "features/settings/producers/producer";
import contractService, { ListContractsFilter } from "features/contracts/contractService";
import calculateNumberOfContracts from './contractCalculator';
import { ShowHide } from  "common/ui/ShowHide";
import loggingService from "common/logging/loggingService";
import deliveryMethodService from "./deliveryMethodService";
import { useSelector } from "react-redux";
import { useTimer, TimerResult } from 'react-timer-hook';
import moment from "moment";
import { DisplayContractsEnum } from "features/contracts/displayContractsEnum";
import { getSecondLastBusinessDayOfLastMonth } from "./helpers";
import * as MerchantActions from 'features/merchants/merchants.actions';
import { Fee, FeeThin, getFeeThin } from "domain/fee";
import AddCustomFieldModal from "./AddCustomFieldModal";
import { CustomField, CustomFieldThin } from "domain/customField";
import { BidViewTypesEnum } from "features/bidEditor/bidViewTypesEnum";
import { MerchantFeature, isFeatureEnabled } from "domain/merchant";
import FormValidation, { FormValidationRefProps } from "common/ui/FormValidation";
import offerTypeHelper from "domain/offerTypeHelper";
import useMarketSchedule from "features/systemConfig/useMarketSchedule";
import { ErpSystem } from "domain/erpSystem";
import { convertToCentralTime, isDateBetween } from "common/dateTimeHelpers";
import FuturesPriceUpdate from "features/futuresContracts/futuresPriceUpdate";
import useAjaxCall from "common/ui/useAjaxCall";
import { withCancellationToken } from "common/http/httpService";
import useDeliveryPeriods from "features/deliveryPeriods/useDeliveryPeriods";
import { localizeOfferContract as localize } from "features/localization/localizeService";
import useTraders from "features/settings/traders/useTraders";
import useHedgingSettings from "features/settings/hedging/useHedgingSettings";
import useFcmAccounts from "features/fcmAccounts/useFcmAccounts";
import useDeliveryMethods from "features/deliveryMethods/useDeliveryMethods";
import usePositionSettings from "features/positions/usePositionSettings";
import useCustomFields from "features/merchants/useCustomFields";
import usePermission from "common/security/usePermission";
import useOfferings from "features/settings/offerings/useOfferings";
import useStoreSelector from "common/redux/useStoreSelector";
import { useDispatch } from "react-redux";
import useReduxAction from "common/redux/useReduxAction";
import { AddOfferProps } from "./AddOfferModal";

const AddOfferModal: React.FC<AddOfferProps> = props => {
    
    const [isShowingConfirmation, showConfirmation] = useState(false);
    const [isSubmitting, showSubmitting] = useState(false);
    const [offer, setOffer] = useState<Offer>(null);
    const [errors, setErrors] = useState<string[]>([]);
    const [isPlaceHedgeOrderChecked, setPlaceHedgeOrderChecked] = useState(true);
    const [isLocationDetermineLater, setLocationDetermineLater] = useState(false);
    const [isShowOfferHedgeSettings, setShowOfferHedgeSettings] = useState(false);
    const [isMarketOrder, setIsMarketOrder] = useState(false);
    const [selectedOrderType, setSelectedOrderType] = useState(null);
    const [doesCommodityBalanceExist, setCommodityBalanceExist] = useState(false);
    const [maxAllowedQuantity, setMaxAllowedQuantity] = useState<number>(null);
    const [allowPriceChange, setAllowPriceChange] = useState(false);
    const [priceLock, setPriceLock] = useState(false);
    const [realTimeFuturesSnapshot, setRealTimeFuturesSnapshot] = useState<FuturesPriceUpdate>(null);
    const [isInitialLocationDetermineLater, setIsInitialLocationDetermineLater] = useState(false);    
    const [remainingContractQuantity, setRemainingContractQuantity] = useState<number>(0);
    const [isOrderTypeManualEntry, setOrderTypeManualEntry] = useState(false);
    const [isCashPriceUpdated, setIsCashPriceUpdated] = useState(false);
    const [allowedDeliveryMethods, setAllowedDeliveryMethods] = useState<DeliveryMethod[]>([]);
    const [allowedPaymentOptions, setAllowedPaymentOptions] = useState<PaymentOption[]>([])
    const [defaultDeliveryMethod, setDefaultDeliveryMethod] = useState<DeliveryMethod>(null);
    const [delayedPriceContracts, setDelayedPriceContracts] = useState<Contract[]>([]);
    const [parentContractFees, setParentContractFees] = useState<FeeThin[]>(null);
    const [futuresContractsLoaded, setFuturesContractsLoaded] = useState<boolean>(false);
    const [showOfferCustomFields, setShowOfferCustomFields] = useState(false);
    const [isCustomFieldsFormValidated, setCustomFieldsFormValidated] = useState(false);
    const [roundCashPrice, setRoundCashPrice] = useState(props.roundCashPrice);
    const [futuresContracts, setFuturesContracts] = useState<FuturesContract[]>(null);
    
    const deliveryPeriods = useDeliveryPeriods(offer?.commodity?.id);
    const customFields = useCustomFields();
    const offerings = useOfferings(true);

    const dispatch = useDispatch();

    const timer: TimerResult = useTimer({ expiryTimestamp: new Date(), autoStart: false, onExpire: () => { onTimerExpired() } });
    
    const marketSchedule = useMarketSchedule();
    const canUsePriceAtOpen = offer?.orderType === OrderType.Market && !marketSchedule.isMarketOpen(offer?.commodity);

    const activeMerchant = useSelector((m: IAppStore) => m.userState.activeMerchant);
    const userConfiguration = useSelector((m: IAppStore) => m.userState.userConfiguration);
    const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);
    const myId = useSelector((m: IAppStore) => m.userState.internalId);
    const myCommodities = useSelector((m: IAppStore) => m.myCommodities);
    const userId = useStoreSelector(m => m.userState.internalId);
    const isMerchantAutoOfferEnabled = activeMerchant.enableAutoOffer;
    const isMerchantAutoPositionEnabled = activeMerchant.enableAutoPosition;
    const fees = useStoreSelector(m => m.merchantFees);

    const deliveryMethodDetails = useDeliveryMethods();

    const canPlaceHedges = usePermission(Permissions.PlaceLimitOrder);
    const canPushBasis = usePermission(Permissions.PushBasis);
    const canManualEntry = usePermission(Permissions.ManualEntry);

    const fcmAccounts = useFcmAccounts();
    const hedgingSettings = useHedgingSettings();
    const positionSettings = usePositionSettings();

    const traders = useTraders();
    const myTrader = traders.find(m => m.userId === myId);

    const displaySendToErpToggle = isFeatureEnabled(activeMerchant, MerchantFeature.SendToErpToggle);

    const formRef = useRef<FormValidationRefProps>(null);
    const customFieldsFormRef = React.createRef<HTMLFormElement>();
    const hedgeSettingsFormRef = useRef<FormValidationRefProps>(null);

    useReduxAction(dispatch => {
        MerchantActions.loadMerchantFees()(dispatch);
    }, []);

    useEffect(() => {
        if (offer?.type == null) return;

        setAllowedPaymentOptions(listPaymentOptionsForOffer(offer.type));

        const contractType = toContractType(offer.type);
        deliveryMethodService.list(contractType)
            .then(setAllowedDeliveryMethods)
            .catch(err => {
                loggingService.error("Unable to retrieve delivery methods", err);
            });
        
        if (props.lockDeliveryMethod) {
            setDefaultDeliveryMethod(props.model.deliveryMethod);
        }
        else {
            setDefaultDeliveryMethod(activeMerchant.contractDeliveryMethodMappings.find(cdm => cdm.contractType === contractType)?.deliveryMethod);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offer?.type]);

    useEffect(() => {
        if (allowedPaymentOptions.length === 0) return;
        
        if (!allowedPaymentOptions.includes(offer?.paymentOption) && !activeMerchant.isPaymentOptionHidden) {
            setOffer({...offer, paymentOption: allowedPaymentOptions[0], deferredPayDate: null});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allowedPaymentOptions])

    useEffect(() => {
        if (futuresContracts == null || offer == null) return;

        if(!futuresContractsLoaded) {
            setFuturesContractsLoaded(true);
            const futuresContract = futuresContracts?.find(fc => fc.id === offer.futuresContract?.id);
            if(futuresContract != null) {
                setOffer({...offer, futuresContract: futuresContract });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [futuresContracts]);

    useEffect(() => {
        if (props.model == null || fees == null) return;

        setIsMarketOrder(myTrader?.orderType === OrderType.Market);
        buildOfferFromModel(props.model, canPushBasis, props.isPricingDelayedPriceContractModal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.model, props.isPricingDelayedPriceContractModal, offerings, fees]);

    useEffect(() => {
        if (offer == null || allowedDeliveryMethods == null || props.isPricingDelayedPriceContractModal || deliveryMethodDetails == null)
            return;

        const forOffer = {...offer};
        forOffer.deliveryMethod = getDeliveryMethod(forOffer);
        forOffer.deliveryTerms = getUpdatedDeliveryTerms(forOffer);

        setOffer(forOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offer?.location?.id, allowedDeliveryMethods, deliveryMethodDetails]);

    useEffect(() => {
        setRealTimePrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offer?.futuresContract?.symbol, offer?.type, selectedOrderType])

    useEffect(() => {
        if(offer == null || realTimeFuturesSnapshot == null) return; 
        setCashPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [realTimeFuturesSnapshot])

    useEffect(() => {
        if(!priceLock){
            setRealTimePrice();
        }
        else {
            priceLockToggle(priceLock);
            timer.restart(getPriceLockTime())
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [priceLock]);

    useEffect(() => {
        if (offer == null) return;
        if(!props.isPricingDelayedPriceContractModal && isPricingDelayedPriceContracts(offer)) {
            getDelayedPriceContractsForCustomer();
        }
        else {
            setDelayedPriceContracts([]);            
            setOffer(currentStateOfOffer => getOffer(currentStateOfOffer));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offer?.producer, offer?.deliveryMethod, offer?.type, offer?.commodity?.id]);

    useEffect(() => {
        if (offer?.delayedContract == null) return;

        setRemainingContractQuantity(offer.delayedContract.remainingQuantity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offer?.delayedContract]);

    useAjaxCall(cxt => {
        if (offer?.commodity == null) return;

        withCancellationToken(futuresContractsService, cxt).listFuturesContracts(offer.commodity.id)
            .then(m => setFuturesContracts(m));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offer?.commodity])
    
    useEffect(() => {
        if (offer != null && !isShowOfferHedgeSettings && !isShowingConfirmation) {
            //Reset the default selected FCM account
            setOffer({...offer, fcmAccount: null});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowingConfirmation, isShowOfferHedgeSettings]);

    useEffect(() => {
        if(props.model == null || props.model.contractId == null) return;

        setParentContractFees(props.model.fees);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.model?.contractId])

    useEffect(() => {
        if(parentContractFees == null) return;
       
        buildOfferFromModel(props.model, canPushBasis, props.isPricingDelayedPriceContractModal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parentContractFees])


    function getDeliveryMethod(forOffer: Offer) {
        const deliveryMethods = listDeliveryMethods(forOffer);
        return deliveryMethods.find(m => forOffer.deliveryMethod === m) 
            ?? deliveryMethods.find(m => defaultDeliveryMethod === m) 
            ?? deliveryMethods.find(m => !isCustomer && forOffer.trader?.defaultDeliveryMethod === m) 
            ?? deliveryMethods[0];
    }

    function getUpdatedDeliveryTerms(forOffer: Offer): string {
        if (!offer)
            return forOffer.deliveryTerms;

        if (forOffer.customerWillSell && !activeMerchant.displayDeliveryTermsWhenCustomerWillSell)
            return null;

        if (!forOffer.customerWillSell && !activeMerchant.displayDeliveryTermsWhenCustomerWillBuy)
            return null;

        const oldDeliveryMethodDetail = deliveryMethodDetails.find(dmd => dmd.deliveryMethod === offer.deliveryMethod);
        const replaceDeliveryTerms = !forOffer.deliveryTerms || forOffer.deliveryTerms === oldDeliveryMethodDetail?.defaultDeliveryTerms;
        if (!replaceDeliveryTerms)
            return forOffer.deliveryTerms;

        const newDeliveryMethodDetail = deliveryMethodDetails.find(dmd => dmd.deliveryMethod === forOffer.deliveryMethod);
        return newDeliveryMethodDetail?.defaultDeliveryTerms;
    }

    function isPricingDelayedPriceContracts(forOffer: Offer) {
        return forOffer?.deliveryMethod === DeliveryMethod.DelayedPrice 
            && forOffer?.producer?.id
            && offerTypeHelper.canHaveDelayedPriceContract(forOffer?.type)
    }

    function getOffer(offer: Offer): Offer {
        let sourceContractId = offer?.sourceContractId;
        if (!([OfferTypeEnum.FixFuturesOnBasis, OfferTypeEnum.FixBasisOnHta].includes(offer?.type) || props.isPricingDelayedPriceContractModal)) {
            sourceContractId = null;
        }
        return { ...offer, delayedContract: null, sourceContractId }
    }

    async function buildOfferFromModel(model: AddOfferModel, isPushBasisEnabled: boolean, isPricingDelayedPriceContract: boolean) {
        const producer = isCustomer ? await producerService.getMyProducer() : model.customer;
        if (isCustomer) {
            producer.accounts = producer.accounts.filter(x => x.canManage);
        }
        const producerAccount = isCustomer && producer.accounts.length > 0 ? producer.accounts[0] : model.customerAccount;
        
        const isFixFutures = model.offerType === OfferTypeEnum.FixFuturesOnBasis;
        const isSetBasis = model.offerType === OfferTypeEnum.FixBasisOnHta;

        const futuresContract = model.futuresContract ?? model.deliveryPeriod?.contract;
        let futuresPrice, basis, cashPrice;

        if (model.commodity?.isCashOnly) {
            futuresPrice = null;
            basis = null,
            cashPrice = model.price ?? 0;
        }
        else {
            futuresPrice = isSetBasis ? model.futuresPrice : futuresContract?.price;
            basis = model.basis ?? model.deliveryPeriod?.bids?.find(m => m.location.id === model.location?.id)?.basis;
            cashPrice = model.price ??  NP.plus(futuresPrice ?? 0, basis ?? 0);
        }

        const newOffer = {
            ...new Offer(),
            sourceContractId: (isFixFutures || isSetBasis || isPricingDelayedPriceContract) ? model.contractId: null,
            displayId: model.displayId,
            type: model.offerType,
            customerWillSell: model.customerWillSell ?? true,
            deliveryMethod: model.deliveryMethod,
            deliveryPeriod: model.deliveryPeriod,
            deliveryPeriodStartDate: model.deliveryPeriod?.start,
            deliveryPeriodEndDate: model.deliveryPeriod?.end,
            futuresContract: futuresContracts?.find(fc => fc.id === futuresContract?.id) ?? futuresContract,
            futuresPrice: futuresPrice,
            location: model.location,
            contractLocation: model.contractLocation,
            commodity: model.commodity,
            orderType: isCustomer ? OrderType.Limit : myTrader?.orderType ?? OrderType.Limit,
            cashPrice: cashPrice,
            basis: basis,
            isBasisFixed: model.isBasisFixed ?? false,
            trader: myTrader,
            producer: producer,
            customerAccount: producerAccount,
            paymentOption: (isFixFutures || isSetBasis || props.isPricingDelayedPriceContractModal) ? model.paymentOption : PaymentOption.Check,
            deferredPayDate: model.deferredPayDate,
            notifyCustomer: activeMerchant.sendNotificationToCustomerDefaultValue, 
            deliveryTerms: model.deliveryTerms,
            customFields: model.customFields,
            disableErpSync: !displaySendToErpToggle,
            currency: getCurrency(model.offerType, model.commodity)
        };

        const isMarketOpen = marketSchedule.isMarketOpen(newOffer.commodity);

        if(newOffer.trader?.priceLock != null && offerTypeHelper.isPriceLockAllowed(newOffer.type)
            && newOffer.orderType == OrderType.Market && isMarketOpen) {
            newOffer.isPriceLocked = true;
            setPriceLock(true);
        }

        if (offerTypeHelper.isHta(newOffer.type)) {
            newOffer.htaFee = model.deliveryPeriod?.htaFee;
        }
        else if(isSetBasis) {
            newOffer.htaFee = model.htaFee;
        }

        if (newOffer.deliveryPeriod?.commodity?.isCashOnly) {
            newOffer.expirationDate = newOffer.deliveryPeriod.end;
        }
        else if(newOffer.type === OfferTypeEnum.BasisContract) {
            newOffer.expirationDate = getSecondLastBusinessDayOfLastMonth(futuresContract?.expiration)
        }
        else if(model.expirationDate) {
            newOffer.expirationDate = model.expirationDate;
        }
        else {
            const expiration = model.deliveryPeriod?.contract?.expiration;
            newOffer.expirationDate =  expiration == null ? null : getPreviousDayForGivenDate(expiration);
        }

        // If user is trader and does not have permissions for both buy & sell
        if (!isCustomer && !(userConfiguration.canBuy && userConfiguration.canSell)) {
            newOffer.customerWillSell = !userConfiguration.canBuy
        }  

        if (isFixFutures || isSetBasis || isPricingDelayedPriceContract) {
            newOffer.producer = model.customer;
            newOffer.customerAccount = model.customerAccount;
            newOffer.customerWillSell = model.customerWillSell;
            newOffer.deliveryMethod = isPricingDelayedPriceContract? DeliveryMethod.DelayedPrice : model.deliveryMethod;
            newOffer.deliveryTerms = getUpdatedDeliveryTerms(newOffer);
            if (isSetBasis) {
                newOffer.expirationDate = model.expirationDate;
                newOffer.htaFee = model.htaFee;
            }
            if (newOffer.location == null) setIsInitialLocationDetermineLater(true);
            newOffer.freightFee = model.freightFee;
            newOffer.rollFee = model.rollFee;
        }     

        if (activeMerchant.isPaymentOptionHidden) {
            newOffer.paymentOption = null;
        }

        const locations = listLocations(newOffer);
        if (!newOffer.location) {
            if (isPushBasisEnabled && canPlaceHedges)
                setLocationDetermineLater(true);
            else {
                newOffer.location = locations[0];
            }
        }

        if (isCustomer) {
            var customerWillSellList = listCustomerWill(newOffer);
            if(customerWillSellList.includes(newOffer.producer.willSellDefaultValue)) {
                newOffer.customerWillSell = newOffer.producer.willSellDefaultValue;
            }
            else
            {
                newOffer.customerWillSell = customerWillSellList.length > 0 ? customerWillSellList[0] : newOffer.customerWillSell;
            }
        }

        if (!newOffer.contractLocation) {
            newOffer.contractLocation = newOffer.location;
        }

        // Adding default buy location to contract and inv location
        if(!newOffer.customerWillSell && newOffer.sourceContractId == null) {
            const defaultBuyLocation = locations.find(l => l.isDefaultBuyLocation);
            if(defaultBuyLocation != null) { 
                newOffer.contractLocation = newOffer.location = defaultBuyLocation;
            }
        }

        if(activeMerchant.displayRegionOnAddOffer) {
            if(newOffer.location?.homeLocation == null) {
                newOffer.region =  newOffer.location == null ? 
                    locations.find(l => l.homeLocation == null) :
                    newOffer.location;
            }
            else {
                newOffer.region =  { ...new PhysicalLocation(),
                        id: newOffer.location.homeLocation.id,
                        name: newOffer.location.homeLocation.name
                    }
            }
        }

        if(!priceLock && canUsePriceAtOpen) {
            newOffer.isPriceAtOpenEnabled = activeMerchant.isPriceAtOpenEnabled && !isMarketOpen;
        }

        const commodities = listCommodities(newOffer);

        if(props.priceAcrossLocations) {
            setRemainingContractQuantity(model.remainingQuantity);
            setMaxAllowedQuantity(model.remainingQuantity);
            setCommodityBalanceExist(true);
        }

        //assign first commodity
        if (isPushBasisEnabled && !model.commodity && commodities.length > 0) {
            //when add offer/contract form is launched using generic add offer button
            newOffer.commodity = { ...commodities[0] };
            newOffer.currency = getCurrency(newOffer.type, commodities[0]);
        }

        setSelectedOrderType(newOffer.orderType);
        (isFixFutures || isSetBasis) && loadCustomerAccountsAndAssociatedOffers(newOffer, commodities, isCustomer ? producer : undefined);

        if(isPricingDelayedPriceContract) {
            const remainingQuantity = props.model.remainingQuantity;
            setRemainingContractQuantity(remainingQuantity);
            const numberOfContracts = calculateNumberOfContracts(newOffer.commodity, remainingQuantity, false)
            newOffer.quantity = remainingQuantity;
            newOffer.numberOfContracts = numberOfContracts;
        }

        if (allowedDeliveryMethods.length > 0 && newOffer?.type != OfferTypeEnum.DelayedPriceContract && !props.isPricingDelayedPriceContractModal) 
        {
            newOffer.deliveryMethod = getDeliveryMethod(newOffer);
            newOffer.deliveryTerms = getUpdatedDeliveryTerms(newOffer);
        }
        
        // Pass Fees from HTA contracts to Set Basis, & Basis Contracts to Set Futures
        newOffer.fees = getFees(newOffer, model);

        newOffer.customFields = listCustomFields(newOffer)
            .filter(cf => cf.defaultValue)
            .map(cf => ({ id: cf.id, name: cf.name, value: cf.defaultValue } as CustomFieldThin));

        setOffer(newOffer);
        loadCommodityBalance(newOffer);
    }

    function getCurrency(offerType: OfferTypeEnum, offerCommodity: Commodity) {
        const commodity = myCommodities.find(x => x.id === offerCommodity?.id);
        return (commodity ? (offerTypeHelper.isHta(offerType) ? commodity.baseCurrency : commodity.localCurrency) : null);
    }

    function getFees(offer: Offer, model: AddOfferModel): FeeThin[] {
        const allowedFees = listFees(offer);
        if(allowedFees.length > 0) {
            //Fees allowed for given new offer, copied from parent
            const copiedFees = model.fees?.filter(f => allowedFees.some(af => af.id === f.id));
            const defaultFees = allowedFees.filter(f => f.isDefault);
            if(defaultFees.length > 0) {
                return defaultFees.map(f => {
                    const fee = copiedFees?.find(cf => cf.id === f.id);
                    return fee != null ? fee : f;
                });
            }
            return copiedFees ?? [];
        }
        return [];
    }

    async function getDelayedPriceContractsForCustomer() {
        // TODO: check what happens with Customer Login
        const filter: ListContractsFilter = { 
            contractType: ContractType.DelayedPrice, 
            displayContracts: DisplayContractsEnum.withNonZeroQuantities, 
            customerId: offer.producer.id,
            commodities: [offer.commodity] };
        const delayedPriceContracts = await contractService.listContracts(filter);        
        if(delayedPriceContracts.totalCount > 0) {
            setDelayedPriceContracts(delayedPriceContracts.results);
            const first = delayedPriceContracts.results[0];
            setRemainingContractQuantity(first.remainingQuantity);

            const newOffer = { ...offer, delayedContract: first, sourceContractId: first.internalId, quantity: first.remainingQuantity };
            setOffer(newOffer);
            loadCommodityBalance(newOffer);
        }
        else {
            setDelayedPriceContracts([]);
            setOffer({ ...offer, delayedContract: null, sourceContractId: null });
        }
    }

    async function loadCustomerAccountsAndAssociatedOffers(newOffer: Offer, commodities: Commodity[], customerProducer?: Producer) {
        let customerAccountsPromise: Promise<Producer>;
        let getAssociatedOffersPromise: Promise<number>;
        if (customerProducer) {
            customerAccountsPromise = Promise.resolve(customerProducer);
        } else if (newOffer?.producer?.id) {
            customerAccountsPromise = producerService.getProducer(newOffer.producer.id);
        }
        if (newOffer.sourceContractId) {
            getAssociatedOffersPromise = contractService.getWorkingQuantities(newOffer.sourceContractId);
        }
        let [producer, contractOffers] = await Promise.all([customerAccountsPromise, getAssociatedOffersPromise]);
 
        const quantity = contractOffers;
        const remainingQuantity = NP.minus(props.model.quantity, quantity);
        setRemainingContractQuantity(remainingQuantity);
        const numberOfContracts = calculateNumberOfContracts(newOffer.commodity, remainingQuantity, false)
        setOffer({ ...newOffer, producer: producer, quantity: remainingQuantity, numberOfContracts });
    }

    function isLoaded(): boolean {
        return props.model != null &&
            offerings != null &&
            allowedDeliveryMethods != null &&
            userConfiguration != null &&
            fees != null && 
            futuresContracts != null;
    }

    function goBack() {
        showConfirmation(false);
        showSubmitting(false);
        setErrors([]);
        if (((isLocationDetermineLater && isPlaceHedgeOrderChecked) || isOrderTypeManualEntry) && offer.type !== OfferTypeEnum.BasisContract) {
            setShowOfferHedgeSettings(true);
            priceLock && timer.pause();
        }
        else {
            priceLock && timer.restart(getPriceLockTime());
        }
    }

    function hedgeSettingsGoBack() {
        showConfirmation(false);
        setShowOfferHedgeSettings(false);
        showSubmitting(false);
        priceLock && timer.restart(getPriceLockTime());
    }

    function customFieldsGoBack() {
        setShowOfferCustomFields(false);
    }

    function customFieldsGoNext() {
        if (customFieldsFormRef.current.checkValidity()) {
            goToHedgingSettings();
        }

        setCustomFieldsFormValidated(true);
    }

    function getPriceLockTime(): Date {
        const priceLockTime = moment(offer.trader?.priceLock, 'HH:mm:ss');
        const expiryTimestamp = moment().add(priceLockTime.minute(), 'minutes').add(priceLockTime.seconds(), 'seconds');
        return expiryTimestamp.toDate();
    }

    function onTimerExpired() {
        setPriceLock(false);
    }

    function goNext() {
        if (formRef.current.validate()) {
            
            //Don't show custom fields for customer
            if(!isCustomer && activeMerchant.useCustomFields && listCustomFields(offer).length > 0) {
                setShowOfferCustomFields(true);
            }
            else {
                goToHedgingSettings();
            }
        }   
    }

    function goToHedgingSettings() {
        if ((isPlaceHedgeOrderChecked || isOrderTypeManualEntry) && offer.type !== OfferTypeEnum.BasisContract) {
            populateDefaultFcmAccount();
            setShowOfferHedgeSettings(true);
        }
        else {
            showConfirmation(true);
        }
        priceLock && timer.pause();
    }

    function populateDefaultFcmAccount(){
        if(offer.fcmAccount == null) {
            let fcmAccountId: number = null;

            //AUT-2780 Use L&S FCM account for cash offers
            if (offerTypeHelper.isCash(offer.type) && !isMerchantAutoOfferEnabled && isMerchantAutoPositionEnabled)
            {
                fcmAccountId = getPositionSettingForOffer(offer);
            }

            if (fcmAccountId == null)
            {
                const offerType = offer.type === OfferTypeEnum.FixFuturesOnBasis ? OfferTypeEnum.Cash : offer.type;
                const hedgingSetting = hedgingSettings?.find(hs => 
                    ((offer.location == null && hs.locationId == null) || (offer.location?.id === hs.locationId)) &&
                    hs.commodityId === offer.commodity.id && hs.offerTypeId === offerType);
                
                if(hedgingSetting != null)
                {
                    fcmAccountId = hedgingSetting.useFcmAccountFromPosition === true ? getPositionSettingForOffer(offer) : hedgingSetting.fcmAccountId;
                }
            }
            
            const defaultFcmAccount = fcmAccounts.find(fa => fa.id === fcmAccountId);
            setOffer({...offer, fcmAccount: defaultFcmAccount});
        }
    }

    function getPositionSettingForOffer(offer: Offer) {
        return positionSettings.find(m => m.commodity.id === offer.commodity.id && 
            m.cropYear.id === offer.deliveryPeriod?.cropYear.id)?.fcmAccount?.id;
    }

    function hedgeSettingsGoNext() {
        if (hedgeSettingsFormRef.current.validate()) {
            showConfirmation(true);
        }
    }

    function getContract(contractType: ContractType): Contract {
        const contract: Contract = new Contract();
        contract.cashPrice = null;
        contract.comments = offer.comments;
        contract.commodity = offer.commodity;
        contract.contractType = contractType;
        contract.contractSubType = offer.contractSubType;
        contract.createdBy = offer.createdBy;
        contract.customerWillSell = offer.customerWillSell;
        contract.deliveryMethod = offer.deliveryMethod;
        contract.commodity = offer.commodity;
        contract.deliveryPeriod = offer.deliveryPeriod;
        contract.deliveryPeriodStartDate = offer.deliveryPeriodStartDate,
        contract.deliveryPeriodEndDate = offer.deliveryPeriodEndDate,
        contract.deliveryTerms = offer.deliveryTerms,
        contract.customerContractId = offer.customerContractId,
        contract.currency = offer.currency?.id,
        contract.expirationDate = offer.expirationDate;
        contract.futuresContract = offer.futuresContract;
        contract.location = offer.location;
        contract.contractLocation = offer.contractLocation;
        contract.region = offer.region;
        contract.paymentOption = offer.paymentOption;
        contract.deferredPayDate = offer.deferredPayDate;
        contract.interestStartDate = offer.interestStartDate;
        contract.interestRate = offer.interestRate;
        contract.freightFee = offer.freightFee;
        contract.premium = offer.deliveryPeriod?.premium;
        contract.producer = offer.producer;
        contract.customerAccount = offer.customerAccount;
        contract.quantityContracted = offer.quantity;
        contract.trader = offer.trader;
        contract.basis = offer.basis;
        contract.isBasisLocked = offer.isBasisFixed;
        contract.sourceContractId = offer.sourceContractId;
        contract.fees = offer.fees;
        contract.rollFee = offer.rollFee;
        contract.customFields = offer.customFields;
        contract.disableErpSync = offer.disableErpSync;
        contract.contractCurrency = offer.currency;
        return contract;
    }

    async function handleSubmit() {
        showSubmitting(true);
        try {
            if (offerTypeHelper.originatesFromOffer(offer.type)) {
                const newOffer: Offer = { ...offer, 
                    htaFee: canPushBasis ? offer.htaFee : null
                };
                if(props.priceAcrossLocations){
                    await OfferActions.priceBalances(newOffer, isPlaceHedgeOrderChecked)(dispatch);
                }
                else {
                    await OfferActions.createOffer(newOffer, isPlaceHedgeOrderChecked)(dispatch);
                }
                props.onAdded && props.onAdded();
            }
            else {
                const contract = getContract(toContractType(offer.type));
                if(props.priceAcrossLocations){
                    await ContractActions.priceBalances(contract)(dispatch);
                }
                else {
                    await ContractActions.createContract(contract)(dispatch);
                }
                props.onAdded && props.onAdded();
            }
            onClose();
        }
        catch (error) {
            showSubmitting(false);
            setErrors((error as ValidationError).errors ?? ["An unknown error occurred"]);
        }
    }

    function onClose() {
        setOffer(null);
        showSubmitting(false);
        showConfirmation(false);
        setLocationDetermineLater(false);
        setShowOfferHedgeSettings(false);
        setErrors([]);
        setPlaceHedgeOrderChecked(true);
        setOrderTypeManualEntry(false);
        setAllowPriceChange(false);
        setPriceLock(false);
        setRealTimeFuturesSnapshot(null);
        setRemainingContractQuantity(0);
        setIsInitialLocationDetermineLater(false);
        setIsCashPriceUpdated(false);
        setDelayedPriceContracts([]);
        setCommodityBalanceExist(false);
        setMaxAllowedQuantity(null);
        setIsMarketOrder(false);
		setSelectedOrderType(null);
		setAllowedDeliveryMethods(null);
		setAllowedPaymentOptions([]);
		setDefaultDeliveryMethod(null);
		setParentContractFees(null);
		setFuturesContractsLoaded(false);
        setShowOfferCustomFields(false);
        setCustomFieldsFormValidated(false);
        props.onClose();
    }

    function listOfferTypes(forOffer: Offer): OfferType[] {
        if (forOffer == null) return [];
        const bidViewType = forOffer?.commodity?.publicBidDisplay;
    
        // Define which offer types to exclude based on the bidViewType
        let excludedOfferTypes: OfferTypeEnum[] = [];
        switch (bidViewType) {
            case BidViewTypesEnum.basisOnly:
                excludedOfferTypes = [OfferTypeEnum.Hta, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice];
                break;
            case BidViewTypesEnum.cashOnly:
                excludedOfferTypes = [OfferTypeEnum.Hta, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.BasisContract];
                break;
            case BidViewTypesEnum.futuresOnly:
                excludedOfferTypes = [OfferTypeEnum.BasisContract, OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice];
                break;
            case BidViewTypesEnum.basisCash:
                // No exclusions if the view is Basis & Cash
                break;
        }
    
        let offerTypes: OfferTypeEnum[] = [];
        if (!isCustomer) {
            if (props.isPricingDelayedPriceContractModal) excludedOfferTypes.push(OfferTypeEnum.DelayedPriceContract);
            offerTypes = (props.contractTypes ?? userConfiguration.allowedContractTypes).map(m => fromContractType(m));
        }
        else {
            if (forOffer.location) {
                const offering = offerings.find(o => o.location?.id === forOffer.location.id && o.commodity.id === forOffer.commodity.id);
                offerTypes = [...offering.offerTypes];
                if (offering.contractTypes.includes(ContractType.Basis)) offerTypes.push(OfferTypeEnum.BasisContract);
                if (offering.contractTypes.includes(ContractType.DelayedPrice)) offerTypes.push(OfferTypeEnum.DelayedPriceContract);
            }
        }
    
        return offerTypes.filter(m => !excludedOfferTypes.includes(m))
            .map(m => ({ id: m, name: getOfferTypeName(m) }));
    }

    function listCustomerWill(forOffer: Offer)
    {
        if (forOffer == null) return [];

        if (!isCustomer)
        {
            if(userConfiguration.canBuy && userConfiguration.canSell)
                return [true, false];
            else 
                return [!userConfiguration.canBuy];
        }  
        
        const offering = offerings
            .find(o => o.location?.id === forOffer.location?.id && o.commodity.id === forOffer.commodity.id);
        
        let customerWillList: boolean[] = [];
        
        if(offering?.allowSelling) customerWillList.push(offering.allowSelling);
        if(offering?.allowBuying) customerWillList.push(!offering.allowBuying);
        
        return customerWillList;
    }

    function isMatch(forOffer: Offer, offering: Offering, commodity?: Commodity, location?: PhysicalLocation): boolean {

        if(isCustomer) {
            if ((forOffer.customerWillSell && !offering.allowSelling) || (!forOffer.customerWillSell && !offering.allowBuying))
                return false;
    
            if (!offering.offerTypes.includes(forOffer.type) && !offering.contractTypes.includes(toContractType(forOffer.type))) 
                return false;
    
            if (offering.deliveryMethods.length === 0) 
                return false;
        }

        if (myTrader != null && !myTrader.locations.some(l => l.id === offering.location.id)) return false;
        
        if (location != null && offering.location.id !== location.id) return false;
        
        if (commodity != null && offering.commodity.id !== commodity.id) return false;

        return true;
    }

    function listCommodities(forOffer: Offer): Commodity[] {

        if (props.model.commodity != null) {
            //Lock down commodity
            const commodity = offerings.find(x=>x.commodity.id === props.model.commodity.id)?.commodity;
            return commodity == null ? [] : [commodity];
        }

        if (forOffer == null) return [];

        return _.uniqBy(offerings
            .filter(o => isMatch(forOffer, o))
            .map(o => o.commodity),
            c => c.id);
    }

    function listFuturesContracts(forOffer: Offer): FuturesContract[] {

        if (forOffer == null || forOffer.commodity == null || listDeliveryPeriods(forOffer).length === 0 || forOffer.commodity.isCashOnly) return [];

        if (!isCustomer && (isLocationDetermineLater || [OfferTypeEnum.Hta, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis].includes(forOffer.type) || (canPushBasis && forOffer.type === OfferTypeEnum.BasisContract))) {
            return _.uniqBy(futuresContracts, f => f.id);
        }
        else if (canPushBasis) {
            return _.uniqBy(deliveryPeriods
                .filter(x => isLocationDetermineLater || x.bids.some(y => y.location.id === forOffer.location?.id))
                .map(x => x.contract), f => f.id);
        }
        else {
            return [forOffer.deliveryPeriod?.contract];
        }
    }

    function listLocations(forOffer: Offer): PhysicalLocation[] {
        if (forOffer == null) return [];

        return _.orderBy(_.uniqBy(offerings
            .filter(o => isMatch(forOffer, o, forOffer.commodity))
            .map(o => o.location),
            l => l.id), l => l.name);
    }

    function listDeliveryMethods(forOffer: Offer): DeliveryMethod[] {
        if (forOffer == null) return [];

        if (forOffer.type === OfferTypeEnum.DelayedPriceContract && activeMerchant.hasErpIntegration){
            return allowedDeliveryMethods.filter(dm => !ExcludedDeliveryMethodsForDPContracts.includes(dm))
        }

        if (isLocationDetermineLater)
            return allowedDeliveryMethods;
        
        return _.uniq(offerings
            .filter(o => isMatch(forOffer, o, forOffer.commodity, forOffer.location))
            .flatMap(o => getDeliveryMethodsForOffering(o)));
    }

    function getDeliveryMethodsForOffering(offering: Offering): DeliveryMethod[] {
        return !isCustomer 
            ? allowedDeliveryMethods
            : _.intersection(offering.deliveryMethods, allowedDeliveryMethods);
    }

    function listDeliveryPeriods(forOffer: Offer): DeliveryPeriod[] {
        if (forOffer == null) return [];
        
        let filteredDeliveryPeriods = deliveryPeriods;

        if (!canPushBasis) //AUT-3527: Traders with Push Basis can choose any delivery period, even if it doesn't have an associated bid
        {
            if (forOffer.location != null && [OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice, OfferTypeEnum.BasisContract].includes(forOffer.type)) {
                filteredDeliveryPeriods = filteredDeliveryPeriods.filter(dp => dp.bids.some(b => (b.location.id === forOffer.location?.id || isLocationDetermineLater) && b.cash != null));//TODO: need to handle bids that don't have cash values
            }

            if (forOffer?.deliveryPeriod != null && !filteredDeliveryPeriods?.some(x => x.id === forOffer?.deliveryPeriod?.id) && [OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.FixFuturesOnBasis].includes(forOffer.type)) {
                filteredDeliveryPeriods =  [...filteredDeliveryPeriods, forOffer.deliveryPeriod];
            }
        }

        if(activeMerchant.erpSystem === ErpSystem.Agris && getCommodityBalanceType(forOffer.deliveryMethod) != null) {
            const nowInCentralTime = convertToCentralTime(new Date());
            filteredDeliveryPeriods = filteredDeliveryPeriods.filter(dp => isDateBetween(nowInCentralTime, dp.start, getNextDayForGivenDate(dp.end)));
        }
        return filteredDeliveryPeriods;
    }

    function listFees(forOffer: Offer): FeeThin[] {
        if(forOffer == null || fees == null || fees.length === 0) return [];

        let allowedFees = fees
            .filter(f => (forOffer.customerWillSell && f.allowSale || !forOffer.customerWillSell && f.allowPurchase) &&
                f.allowedCommodities.includes(forOffer.commodity?.id) &&
                (f.allowedOfferTypes.includes(forOffer.type) || f.allowedContractTypes.includes(getContractTypeForFees(forOffer.type))))
            .map(f => getFeeThin(f));

            // Adding the fees coming from parent contract while setting futures or basis
        if(forOffer.sourceContractId != null && parentContractFees?.length > 0) {
            const missingParentFees = _.differenceBy(parentContractFees, allowedFees, m => m.id);
            allowedFees = [...allowedFees, ...missingParentFees];
        }

        return allowedFees;
    }

    function listCustomFields(forOffer: Offer): CustomField[] {
        if(forOffer == null || customFields == null || customFields.length === 0) return [];

        let allowedCustomFields = customFields
        .filter(f => 
            !f.mappedField && 
            (forOffer.customerWillSell && f.allowSale || !forOffer.customerWillSell && f.allowPurchase) &&
            (f.allowedOfferTypes.includes(forOffer.type) || f.allowedContractTypes.includes(getContractTypeForFees(forOffer.type))) &&
            f.allowedCommodities.includes(forOffer.commodity.id)
        );

        return allowedCustomFields;
    }

    function getContractTypeForFees(offerType: OfferTypeEnum): ContractType {
        if([OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.FixFuturesOnBasis].includes(offerType))
            return null;

        return toContractType(offerType);
    }

    function getPriceIncrement() {
        const commodities = listCommodities(offer);
        return commodities.find(x => x.id === offer.deliveryPeriod?.commodity?.id)?.bidPriceIncrement;
    }

    function togglePriceFieldState(price: number) {        
        const step = getPriceIncrement() ?? .01;
        const remainder = NP.divide(NP.times(price, 10_000) % NP.times(step, 10_000), 10_000);
        if (remainder === 0) { // if current price is whole number then price change shouldn't be allowed
            setAllowPriceChange(false);
        }
        else {
            setAllowPriceChange(true);
        }
    }

    function priceLockToggle(priceLock: boolean) {
        if (offer == null) return;
        onOfferUpdated({...offer, 
            isPriceLocked: priceLock,
            snapshotPrice: priceLock ? realTimeFuturesSnapshot?.price : null,
            snapshotTime: priceLock ? realTimeFuturesSnapshot?.priceDateTime : null
        });
    }

    function onOfferUpdated(forOffer: Offer): void {
        //Make sure all the other values are still valid.
        const locations = listLocations(forOffer);
        forOffer.location = locations.find(m => m.id === forOffer.location?.id);
        forOffer.contractLocation = activeMerchant.displayContractLocation ? locations.find(m => m.id === forOffer.contractLocation?.id) : forOffer.location;
        forOffer.deliveryMethod = listDeliveryMethods(forOffer).find(m => m === forOffer.deliveryMethod);
        forOffer.deliveryPeriod = listDeliveryPeriods(forOffer).find(m => m?.id === forOffer.deliveryPeriod?.id) ?? forOffer.deliveryPeriod;
        forOffer.deliveryTerms = getUpdatedDeliveryTerms(forOffer);

        if (offerTypeHelper.isHta(forOffer.type)) {
            forOffer.isBasisFixed = false;
            //if user doesn't have push basis permission or offer type is changed to HTA then set default
            if (!canPushBasis || forOffer.type != offer.type) forOffer.htaFee = forOffer.deliveryPeriod?.htaFee;
        }
        else if(forOffer.type !== OfferTypeEnum.FixBasisOnHta) {
            forOffer.htaFee = null;
        }

        let isLocationDetermineLater = forOffer.location == null;
        setLocationDetermineLater(isLocationDetermineLater); 

        let isMarketOrder = forOffer.orderType === OrderType.Market; 
        setIsMarketOrder(isMarketOrder);

        if (forOffer.orderType && forOffer.orderType !== offer.orderType) {
            setSelectedOrderType(forOffer.orderType); 
            setIsCashPriceUpdated(false);
        } 

        if (forOffer.commodity?.id !== offer.commodity?.id || forOffer.type !== offer.type) {
            forOffer.currency = getCurrency(forOffer.type, forOffer.commodity);
            forOffer.customFields = listCustomFields(forOffer)
                        .filter(cf => cf.defaultValue)
                        .map(cf => ({ id: cf.id, name: cf.name, value: cf.defaultValue } as CustomFieldThin));
        }

        if(forOffer.type !== offer.type || forOffer.customerWillSell !== offer.customerWillSell || 
            forOffer.commodity?.id !== offer.commodity?.id) {
            forOffer.fees = listFees(forOffer).filter(f => f.isDefault);
        }

        //ManualEntry order type can be selected only with offer type Cash. When type is changed from cash to HTA and previously selectedOrderType is ManualEntry 
        //then we have to reset
        if (forOffer.type && forOffer.type !== offer.type &&
            selectedOrderType === OrderType.ManualEntry && !offerTypeHelper.isCash(forOffer.type)) {
                const trader = traders?.find(m => m.userId === userId);
                forOffer.orderType = trader.orderType;
                setSelectedOrderType(trader.orderType);
        }

        setOrderTypeManualEntry(forOffer.orderType === OrderType.ManualEntry);

        if (!(isLocationDetermineLater || canPushBasis || [OfferTypeEnum.Hta, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis].includes(forOffer.type))) {
            forOffer.futuresContract = forOffer.deliveryPeriod?.contract;
        }  

        if (!offerTypeHelper.isPriceLockAllowed(forOffer.type) || forOffer.orderType !== OrderType.Market) {
            forOffer.isPriceLocked = false;
            setPriceLock(false);
        }

        const basis = getBasis(forOffer.deliveryPeriod, forOffer.location, forOffer.type);
        //set basis
        if (!forOffer.isBasisFixed) {            
            forOffer.basis = basis;
        }
        else if (forOffer.isBasisFixed !== offer.isBasisFixed && forOffer.orderType !== OrderType.ManualEntry) {
            forOffer.basis = offer.basis;
        }        

        const futuresPrice = realTimeFuturesSnapshot?.price ?? 0;
        let roundCashPrice = shouldRoundCashPrice(forOffer) && !isCashPriceUpdated;
        //set price
        if (forOffer.type === OfferTypeEnum.FixBasisOnHta) {
            forOffer.futuresPrice = props.model.futuresPrice;
            forOffer.cashPrice = NP.plus(props.model.futuresPrice ?? 0, forOffer.basis ?? 0);
        }
        else {
            if(forOffer.orderType === OrderType.Market) {
                if (forOffer.commodity.isCashOnly) {
                    forOffer.cashPrice = forOffer.deliveryPeriod?.bids?.find(x => x.location.id === forOffer.location.id).cash;
                }
                else {
                    if (!priceLock) {
                        forOffer.futuresPrice = futuresPrice;
                        const price = NP.plus(futuresPrice, forOffer.basis ?? 0);
                        forOffer.cashPrice = price;
                        setIsCashPriceUpdated(false);
                    }
                }
            } 
            else if (!isCashPriceUpdated) {
                if (forOffer.isBasisFixed !== offer.isBasisFixed && !forOffer.isBasisFixed) { 
                    //fixBasis flag has been changed
                    setPriceForOffer(forOffer, futuresPrice);
                }
                else if((forOffer.futuresContract?.id !== offer.futuresContract?.id) || 
                (forOffer.location?.id !== offer.location?.id) || (forOffer.type !== offer.type)) { 
                    //symbol or location has been changed
                    forOffer.futuresPrice = futuresPrice;
                    setPriceForOffer(forOffer, futuresPrice);
                }
                else if (forOffer.deliveryPeriod?.id !== offer.deliveryPeriod?.id) { 
                    //deliveryPeriod has been changed
                    forOffer.futuresPrice = futuresPrice;
                    setPriceForOffer(forOffer, futuresPrice);
                }
                else if (forOffer.type === OfferTypeEnum.FixFuturesOnBasis || forOffer.orderType === OrderType.ManualEntry) { 
                    //FixFutures modal
                    setPriceForOffer(forOffer, forOffer.futuresPrice);
                }
                else {
                    // This is when basis or price are incremented or decremented using arrow keys
                    if(forOffer.orderType === offer.orderType && forOffer.cashPrice !== offer.cashPrice){
                        setIsCashPriceUpdated(true);
                        roundCashPrice = false;
                    }

                    if (forOffer.orderType == OrderType.Tas) {
                        forOffer.cashPrice = 0;
                    }
                    else {
                        forOffer.cashPrice = NP.plus(forOffer.cashPrice ?? 0, NP.minus(forOffer.basis ?? 0, offer.basis ?? 0));
                    }
                }
            }
        }

        //priceLock - enable or disable price change
        if(priceLock) {
            const price = forOffer.type == OfferTypeEnum.FixFuturesOnBasis ? forOffer.futuresPrice : forOffer.cashPrice;
            togglePriceFieldState(price);
            // Just to consider rounding up and down with price lock.
            forOffer.snapshotPrice = NP.minus(forOffer.cashPrice ?? 0, forOffer.basis ?? 0);
            //FixFutures modal with Price lock enabled
            if (isMarketOrder && forOffer.type === OfferTypeEnum.FixFuturesOnBasis) {
                forOffer.cashPrice = NP.plus(forOffer.futuresPrice ?? 0, forOffer.basis ?? 0);
            }
        }
        else {
            setAllowPriceChange(false);
        }

        if ([OfferTypeEnum.BasisContract, OfferTypeEnum.DelayedPriceContract].includes(forOffer.type)) {
            forOffer.cashPrice = null;
            setIsCashPriceUpdated(false);
            setIsMarketOrder(false);
            if (forOffer.type === OfferTypeEnum.DelayedPriceContract) {
                forOffer.basis = null;
                forOffer.futuresContract = null;
                forOffer.deliveryPeriod = null;
                forOffer.deliveryMethod = activeMerchant.hasErpIntegration ? forOffer.deliveryMethod : DeliveryMethod.DelayedPrice;
                forOffer.deliveryTerms = getUpdatedDeliveryTerms(forOffer);
            }
        }

        // Added Rounding logic
        if(roundCashPrice) {
            forOffer.cashPrice =  getRoundedCashPrice(forOffer, forOffer.cashPrice);
        }

        // Fetch commodity balance from ERP if location, commodity, delievery method or producer account is changed.
        if ((forOffer.deliveryMethod !== offer.deliveryMethod || forOffer.location?.id !== offer.location?.id ||
            forOffer.producer?.id !== offer.producer?.id || forOffer.customerAccount?.accountId !== offer.customerAccount?.accountId || 
            forOffer.commodity?.id !== offer.commodity?.id)) {
            loadCommodityBalance(forOffer);
        }
        setRoundCashPrice(roundCashPrice);
        setOffer(forOffer);
    }

    function setPriceForOffer(forOffer: Offer, futuresPrice: number) {
        if (forOffer.orderType == OrderType.Tas) {
            forOffer.cashPrice = 0;
            setIsCashPriceUpdated(true);
        }
        else if (forOffer.commodity?.isCashOnly) {
            if (forOffer.location != null) {
                forOffer.cashPrice = forOffer.deliveryPeriod?.bids?.find(x => x.location.id === forOffer.location.id).cash;
            }
        }
        else {
            forOffer.cashPrice = NP.plus(futuresPrice ?? 0, forOffer.basis ?? 0);
        }
    }
    function shouldFetchCommodityBalance(forOffer: Offer) {

        if(props.isPricingDelayedPriceContractModal && isPricingDelayedPriceContracts(forOffer))
            return false;

        if([OfferTypeEnum.FixFuturesOnBasis, OfferTypeEnum.FixBasisOnHta].includes(forOffer?.type))
            return false;
        
        if(forOffer.deliveryMethod === DeliveryMethod.DelayedPrice && forOffer.delayedContract != null)
            return false;

        return true;
    }

    async function loadCommodityBalance(forOffer: Offer) {
        if(props.priceAcrossLocations) return;
        
        const commodityBalanceType = getCommodityBalanceType(forOffer.deliveryMethod);

        if(forOffer.location?.id && forOffer.commodity?.id && forOffer.producer?.id && 
            commodityBalanceType && forOffer.customerAccount && shouldFetchCommodityBalance(forOffer)) {
            const request = {
                locationId: forOffer.location.id,
                commodityId: forOffer.commodity.id,
                producerId: forOffer.producer.id,
                producerAccountId: forOffer.customerAccount?.accountId,
                commodityBalanceType: commodityBalanceType
            };

            try {
                const result = await commodityBalanceService.getCommodityBalance(request);
                
                setCommodityBalanceExist(result != null);
                setMaxAllowedQuantity(result?.quantity ?? forOffer.quantity);
            }
            catch (err) {
                loggingService.error("Unable to retrieve commodity balance", err as Error);
            }
        }
        else {
            setCommodityBalanceExist(false);
            setMaxAllowedQuantity(null);
        }
    }

    function setCashPrice() {
        const basis = getBasis(offer.deliveryPeriod, offer.location, offer.type);

        //set basis
        if (!offer.isBasisFixed) {            
            offer.basis = basis;
        }      

        let cashPrice = NP.plus(realTimeFuturesSnapshot?.price ?? 0, offer.basis ?? 0);

        // Added Rounding logic
        if(shouldRoundCashPrice(offer)) {
            cashPrice =  getRoundedCashPrice(offer, cashPrice);
        }

        const updatedOffer = {...offer, 
            futuresPrice: realTimeFuturesSnapshot?.price, 
            cashPrice: cashPrice,
            isPriceLocked: priceLock,
            snapshotPrice: priceLock ? realTimeFuturesSnapshot?.price : null,
            snapshotTime: priceLock ? realTimeFuturesSnapshot?.priceDateTime : null
        };

        setOffer(updatedOffer);
        setIsCashPriceUpdated(false);
    }

    function shouldRoundCashPrice(offer: Offer) {
       return props.roundCashPrice && offerTypeHelper.isCash(offer.type) && offer.deliveryPeriod != null
            && ![OrderType.Tas, OrderType.ManualEntry].includes(offer.orderType);
    }

    function getRoundedCashPrice(offer: Offer, cashPrice: number) {
        return roundCents(cashPrice, (offer.futuresContract?.isSettled ? 
            offer.deliveryPeriod.commodity.roundingOnClose : 
            offer.deliveryPeriod.commodity.roundingInSession));
    }
    
    async function setRealTimePrice() {
        if(offer?.futuresContract == null || offer.orderType === OrderType.Tas) return;

        // Fetch the real time price if offer type is cash, HTA or fix futures on basis, and:
        // 1. order type is Market, or
        // 2. order type is Limit and user has not manually set the price
        if(offerTypeHelper.hasFuturesPrice(offer.type) &&
            (offer.orderType === OrderType.Market || !isCashPriceUpdated)) {
            const snapshot = await futuresContractsService.getRealTimeSnapshot(offer.futuresContract.id);
            setRealTimeFuturesSnapshot(snapshot);
        }
    }

    function getTitle() {
        if (isShowingConfirmation) {
            if (offer?.type === OfferTypeEnum.FixFuturesOnBasis) return localize("AddOfferModal_Header_ReviewFutures");
            else if (offer?.type === OfferTypeEnum.FixBasisOnHta) return localize("AddOfferModal_Header_ReviewBasis");

            return localize('AddOfferModal_Header_ReviewOfferContract');
        }
        else if (isShowOfferHedgeSettings) {
            return localize("AddOfferModal_Header_HedgeSelections");
        }
        else if (showOfferCustomFields) {
            return localize("AddOfferModal_Header_CustomFieldSelections");
        }
        else {
            if (offer?.type === OfferTypeEnum.FixFuturesOnBasis) return localize("AddOfferModal_Header_SetFutures");
            else if (offer?.type === OfferTypeEnum.FixBasisOnHta) return localize("AddOfferModal_Header_SetBasis");

            return localize("AddOfferModal_Header_AddOfferContract");
        }
    }

    function getBasis(deliveryPeriod: DeliveryPeriod, location: PhysicalLocation, offerType: OfferTypeEnum): number {
        if (deliveryPeriod?.commodity?.isCashOnly) {
            return null;
        }
        if (offerType === OfferTypeEnum.FixFuturesOnBasis) {
            return props.model.basis;
        }
        else if (location == null || offerTypeHelper.isHta(offerType)) {
            return null;
        }
        else {
            const bids = deliveryPeriod?.bids?.find(x => x.location?.id === location?.id);
            return bids?.basis;
        }
    }

    return !isLoaded()
        ? <></>
        : (
        <Modal show onHide={onClose} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    {getTitle()}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="add-offer-modal">
                <ShowHide show={!showOfferCustomFields && !isShowingConfirmation && !isShowOfferHedgeSettings}>
                    <FormValidation ref={formRef}>
                        <AddOfferDetails
                            offer={offer}
                            isPlaceHedgeOrderChecked={isPlaceHedgeOrderChecked}
                            setPlaceHedgeOrderChecked={setPlaceHedgeOrderChecked}
                            isLocationDetermineLater={isLocationDetermineLater}
                            canPlaceHedges={canPlaceHedges}
                            canPushBasis={canPushBasis && !props.priceAcrossLocations}
                            canManualEntry={canManualEntry}
                            isMerchantAutoOfferEnabled={isMerchantAutoOfferEnabled}
                            isMerchantAutoPositionEnabled={isMerchantAutoPositionEnabled}
                            isPricingDelayedPriceContract={props.isPricingDelayedPriceContractModal}
                            selectedOrderType={selectedOrderType}
                            allowPriceChange={allowPriceChange}
                            offerTypes={listOfferTypes(offer)}
                            customerWill={listCustomerWill(offer)}
                            locations={listLocations(offer)}
                            traders={traders}
                            delayedPriceContracts={delayedPriceContracts}
                            canChangeCommodity={props.model.commodity == null}
                            isMarketOrder={isMarketOrder}
                            isPriceLocked={priceLock}
                            isInitialLocationDetermineLater={isInitialLocationDetermineLater}
                            remainingContractQuantity={remainingContractQuantity}
                            setPriceLock={setPriceLock}
                            commodities={listCommodities(offer)}
                            deliveryMethods={listDeliveryMethods(offer)}
                            deliveryPeriods={listDeliveryPeriods(offer)}
                            futuresContracts={listFuturesContracts(offer)}
                            timer={timer}
                            paymentOptions={allowedPaymentOptions}
                            userIsTrader={!isCustomer}
                            onOfferUpdated={onOfferUpdated}
                            doesCommodityBalanceExist={doesCommodityBalanceExist}
                            maxAllowedQuantity={maxAllowedQuantity}
                            positionSettings={positionSettings}
                            isCashPriceUpdated={isCashPriceUpdated}
                            isPricingDelayedPriceContractModal={props.isPricingDelayedPriceContractModal}
                            showPaymentOption={!activeMerchant.isPaymentOptionHidden}
                            realTimeFuturesPrice={realTimeFuturesSnapshot?.price}
                            allowPickingCustomer={props.model.customer == null}
                            fees={listFees(offer)}
                            priceAcrossLocations={props.priceAcrossLocations}
                            lockDeliveryMethod={props.lockDeliveryMethod}
                            allowCustomerToChangeType={props.allowCustomerToChangeType}
                            roundCashPrice={roundCashPrice}
                            />
                    </FormValidation>
                </ShowHide>
            {showOfferCustomFields && !isShowOfferHedgeSettings && !isShowingConfirmation &&
                <Form ref={customFieldsFormRef} validated={isCustomFieldsFormValidated}>
                    <AddCustomFieldModal 
                        customFields={listCustomFields(offer)}
                        selectedCustomFields={offer?.customFields ?? []}
                        onCustomFieldsChanged={cf => setOffer({...offer, customFields: cf})}
                     />
                </Form>
            }
            { isShowingConfirmation && !isSubmitting && offer != null &&
            <>
                <OfferDetailsConfirmation 
                    offer={offer} 
                    errors={errors}
                    showPaymentOption={!activeMerchant.isPaymentOptionHidden}
                    showHedgeSettings={isPlaceHedgeOrderChecked} />
            </>
            }
            {isShowOfferHedgeSettings && !isShowingConfirmation &&
                <FormValidation ref={hedgeSettingsFormRef}>
                    <OfferHedgeSettings 
                        offer={offer}
                        fcmAccounts={fcmAccounts}
                        onOfferUpdated={onOfferUpdated}
                        isPlaceHedgeOrderChecked={isPlaceHedgeOrderChecked}
                        setPlaceHedgeOrderChecked={setPlaceHedgeOrderChecked} />
                </FormValidation>
            }
            { isShowingConfirmation && isSubmitting &&
                <Spinner animation="border" />
            }
            </Modal.Body>
            <Modal.Footer>
                {!showOfferCustomFields && !isShowingConfirmation && !isShowOfferHedgeSettings &&
                    <>
                    <Button variant="secondary" onClick={onClose}>
                        {localize("AddOfferModal_Button_Cancel")}
                    </Button>
                    <Button variant="primary" onClick={goNext}>
                        {localize("AddOfferModal_Button_Next")}
                    </Button>
                    </>
                }
                { isShowingConfirmation &&
                    <>
                    <Button variant="secondary" className="mr-auto" onClick={goBack} disabled={isSubmitting}>
                        {localize("AddOfferModal_Button_BackAndEdit")}
                    </Button>
                    <Button variant="secondary" onClick={() => { showConfirmation(false); onClose(); }} disabled={isSubmitting}>
                        {localize("AddOfferModal_Button_Cancel")}
                    </Button>
                    <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                        {localize("AddOfferModal_Button_Submit")}
                    </Button>
                    </>
                }
                {showOfferCustomFields && !isShowOfferHedgeSettings && !isShowingConfirmation &&
                    <>
                    <Button variant="secondary" onClick={customFieldsGoBack}>
                        {localize("AddOfferModal_Button_BackAndEdit")}
                    </Button>
                    <Button variant="primary" onClick={customFieldsGoNext} >
                        {localize("AddOfferModal_Button_Next")}
                    </Button>
                    </>
                }
                {!isShowingConfirmation && isShowOfferHedgeSettings &&
                    <>
                        <Button variant="secondary" onClick={hedgeSettingsGoBack}>
                            {localize("AddOfferModal_Button_BackAndEdit")}
                        </Button>
                        <Button variant="primary" onClick={hedgeSettingsGoNext} >
                            {localize("AddOfferModal_Button_Next")}
                        </Button>
                    </>
                }
            </Modal.Footer>
        </Modal>
    );
}

export default AddOfferModal